/** Max length for positive behaviour name and award description text fields. */
const MAX_TEXT_FIELD_LENGTH = 250
const MAX_NAME_LENGTH = MAX_TEXT_FIELD_LENGTH
const MAX_AWARD_DESCRIPTION_LENGTH = MAX_TEXT_FIELD_LENGTH
const POINTS_MIN = 1
const POINTS_MAX = 99

/** POST create — `apiV8nocache` base is already `/api/v8`. */
const POSITIVE_BEHAVIOURS_API_PATH = "/admin/pbis/positive-behaviors"

const STATUS = Object.freeze({
  ENABLED: "Enabled",
  DISABLED: "Disabled"
})

export default {
  MAX_TEXT_FIELD_LENGTH,
  MAX_NAME_LENGTH,
  MAX_AWARD_DESCRIPTION_LENGTH,
  POINTS_MIN,
  POINTS_MAX,
  POSITIVE_BEHAVIOURS_API_PATH,
  STATUS
}
